export const vector = {
    get: (x = 0, y = 0, z = 0) => {
        return {x, y, z};
    },
    add: (v1, v2) => {
        return {x: v1.x + v2.x, y: v1.y + v2.y, z: v1.z + v2.z};
    },
    multiply: (vector, number) => {
        return {x: vector.x * number, y: vector.y * number, z: vector.z * number};
    },
    dot: (v1, v2) => dotProduct(v1, v2),
    length: (v) => Math.sqrt(dotProduct(v, v))
}

const dotProduct = (v1, v2) => {
    return v1.x * v2.x + v1.y * v2.y + v1.z * v2.z;
}